module.exports = __webpack_public_path__ + "static/media/img-default.66cb0ed3.jpg";